// extracted by mini-css-extract-plugin
export default {"avatarGroup":"trips-trip-avatars-TripAvatars__avatarGroup--2NC3g","default":"trips-trip-avatars-TripAvatars__default--ow1K-"};